import { gql, useQuery } from '@apollo/client';
import { get } from 'lodash';

const getBridgeAvailabilityQuery = gql`
  query getBridgeAvailabilityQuery($jobName: String!) {
    bridgeConnectionAvailability(jobName: $jobName)
  }
`;

const useBridgeAvailability = ({ jobName }) => {
  const { data } = useQuery(getBridgeAvailabilityQuery, {
    variables: {
      jobName
    },
    fetchPolicy: 'cache-and-network',
  });

  const isBridgeAvailable = get(data, 'bridgeConnectionAvailability');

  return { isBridgeAvailable };
};

export default useBridgeAvailability;
